import React from 'react';

interface GraphQLErrorListProps {
	errors: {
		message: string;
	}[];
}

export function GraphQLErrorList({ errors }: GraphQLErrorListProps) {
	return (
		<div>
			<h1>GraphQL Error</h1>
			{errors.map((error) => (
				<pre key={error.message}>{error.message}</pre>
			))}
		</div>
	);
}
